/**
 * Toolpad entry point kept for `dialogs.open(NewUser, { organization })`
 * callers (AddNewUserButton on the organization page). The dialog itself is
 * UserFormDialog; this adapter only maps toolpad's open/onClose/payload onto
 * its controlled props.
 */
import type { IOrganization } from "@/api";
import type { DialogProps } from "@toolpad/core";

import { UserFormDialog } from "./UserFormDialog";

interface IProps {
    /** The organization to add a new user to. */
    organization?: IOrganization;
}

export const NewUser = ({ open, onClose, payload }: DialogProps<IProps>) => (
    <UserFormDialog
        open={open}
        onOpenChange={(next) => {
            if (!next) onClose();
        }}
        defaultOrganization={payload.organization ?? null}
    />
);

export default NewUser;
